import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppUser } from '@classes/auth/infosUser';
import { NavLinks } from '@classes/navlinks/navlinks';
import { faGlobeEurope } from '@fortawesome/free-solid-svg-icons';
import { DataService } from '@services/data/data.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';

@Component({
  selector: 'app-smartwaste-home',
  templateUrl: './smartwaste-home.component.html',
  styleUrls: ['./smartwaste-home.component.scss']
})
export class SmartwasteHomeComponent extends SubscriptionBaseComponent implements OnInit {

  fafaGlobeEurope = faGlobeEurope;

  userAppSelected: AppUser;

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef

  ) {
    super();
  }

  ngOnInit(): void {

    this.dataService.appName.next('SmartWaste');
    this.dataService.logoApp.next(faGlobeEurope);
    this.initSub();

  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.userAppSelected.subscribe({
          next: userAppSelected => { this.userAppSelected = userAppSelected; this.cdr.detectChanges(); }

        })
      );
  }
}
